import { render, staticRenderFns } from "./BlockCurtain.vue?vue&type=template&id=5b8bb86e&scoped=true&"
import script from "./BlockCurtain.vue?vue&type=script&lang=ts&"
export * from "./BlockCurtain.vue?vue&type=script&lang=ts&"
import style0 from "./BlockCurtain.vue?vue&type=style&index=0&id=5b8bb86e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8bb86e",
  null
  
)

export default component.exports